// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"uikit_wrapper__2IdOY","list":"uikit_list__Bd9CV"};